export default "__VITE_ASSET__Bxnldrnt__"